export default "__VITE_ASSET__BIvguPWY__"